var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"width":"610"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('task-card',{attrs:{"task":_vm.task,"description-height":280,"can-interact":_vm.canInteract}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }